import styled from 'styled-components';

export const PageContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    width: 100%;
`;
export const Main = styled.main`
    flex: 1;
`;